import React, { useEffect, useState } from 'react';
import '../../../styles/mainContents.css';
import { resetNoticeMessage, fetchInsertItemsRow, setAddConsignmentPopup } from '../../../redux/actions/consignmentsPostActions';
import { useDispatch, connect } from 'react-redux';
import ErrorHandlerAlert from '../../error/ErrorHandlerAlert';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { JsonWebTokenError } from 'jsonwebtoken';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

function InsertItemModel(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const [ show, setShow ] = useState(false);

  const [ insertItemState, setInsertItemState ] = useState({
    CONSIGNMENTID: null,
    CUSTNO: '',
    PRDID: null,
    PARTNO: '',
    // ONHAND: 0,
    CONSIGN: 0
    // CONSIGNED_ON: moment().format("YYYY-MM-DD"),
    // LAST_SALE: null,    
    // LAST_ACTIVITY: null,
    // PROFILE_PRICE: 0.00,
    // CORE_PRICE: 0.00,
    // LAST_SALE_PRICE: 0.00                                
  });  
  const { reset_NoticeMessage, noticeMessage, set_AddConsignmentPopup, addConsignmentPopup, authreducerState, fetch_insertItemsRow} = props;

  useEffect( () => {
    setShow(false);
    if(addConsignmentPopup.showModel === 'insert'){
      setShow(true);

      if(document.getElementById('addModal') !== null){
        document.getElementById('addModal').style.display = "block";
      }      
    }
  }, [addConsignmentPopup]);
  
  useEffect( () => {
    if(noticeMessage !== null){

      if(noticeMessage !== '' && noticeMessage.length > 0){
        if(window.confirm(noticeMessage) === true){
          alert('TODO -- yes')

          //TODO
          //fetchEdit

          //alert status

          //clear insert state if success
        }
        // else{
        //   alert('no')          
        // }

        reset_NoticeMessage('');
      }

    }
  }, [noticeMessage,reset_NoticeMessage]);

  // const saveInput = () => {
  //   if(addConsignmentPopup.custnoClicked !== ''){
  //     setInsertItemState({...insertItemState, CUSTNO: addConsignmentPopup.custnoClicked })
  //    console.log('saveInput added custno')
  //   }
  // }

  let addConsignmentItemBtnConfirmOnClick = () => {
    console.log('addConsignmentItemBtnConfirmOnClick called insertItemState: ' + JSON.stringify(insertItemState), 'addConsignmentPopup', addConsignmentPopup, 'addConsignmentPopup.custClickedDetails',addConsignmentPopup.custClickedDetails)
      
    //validate inputs 

    if(addConsignmentPopup.custnoClicked === '' && insertItemState['CUSTNO'] === ''){
      console.log("Add failed. Enter a valid CUSTNO input: " + insertItemState['CUSTNO'])
      alert("Add failed. Enter a valid CUSTNO input: " + insertItemState['CUSTNO'])
      return false
    }   

    //TODO validate custno and get consignmentid after leaving textbox;   
    if(addConsignmentPopup.partnoClicked === '' && insertItemState['PARTNO'] === ''){
      alert("Add failed. Enter a valid PARTNO input: " + insertItemState['PARTNO'])
      return false
    }   


    fetch_insertItemsRow(insertItemState, addConsignmentPopup)
  }  

  const closeAddModalClick = () => {
    // document.getElementById('addModal').style.display = "none";

    set_AddConsignmentPopup({ 
      ...addConsignmentPopup,     
      showModel: false,
      
    })    
  };


  const validateDate = () => {
    //TODO: calendar
    // if(calendarCols.includes(col)){
    //   editInputField.type = 'date';
    //   let today = moment();
    //   editInputField.max = today.format("YYYY-MM-DD");

    //   let currDateValue = moment(consignmentStateColData, "MM/DD/YYYY").format("YYYY-MM-DD"); //format to HTML5 date format
    //   editInputField.value = currDateValue
    //   editInputField.addEventListener("blur", function(e){
    //     let userInput = e.target.value
    //     let isDateValid = moment(userInput).isValid()

    //     if (isDateValid){
    //       let userInputDate = moment(userInput)
    //       if (userInputDate > today){
    //         alert("Invalid date. Please re-enter date if necessary.");
    //         editInputField.value = currDateValue  //revert change
    //       }
    //     }
    //     else{
    //       if(userInput !== ''){
    //         alert("Invalid date. Please re-enter date if necessary.");
    //         editInputField.value = currDateValue    //revert change
    //       }
    //     }
    //     console.log("currDateValue:" + currDateValue + " userInput: " + userInput + " isDateValid:" + isDateValid)
    //   });

  }

  return (

    <div>
      {/* {console.log('InsertItemModel called addConsignmentPopup:' + JSON.stringify(addConsignmentPopup))} */}


      <main>

        <div>
          <div>
            {!authreducerState.isLoggedIn ? (

              <React.Fragment>
                {history.push('/login')}
              </React.Fragment>
            ) : (
              <div></div>
            )}

            {show && 
            
            (
              <React.Fragment>
               { /* <!-- The Add Modal --> */ }
                <div id="addModal" className="modal" >

                    {/* <!-- Modal content --> */}
                    <div className="modal-content_Small">
                        <span className="modalHeader">
                            <span className="infoPrompt">Insert Consignment <FontAwesomeIcon icon={faInfo} style={{fontSize:"18"}}/>
                                <span className="popupInfoText">Note -- Note</span>
                            </span>
                            <span id='closeAddModalId' className="close" onClick={()=> {closeAddModalClick();}}>&times;</span>
                        </span>

                        <div id='addModalBodyId' className="modalBody">                      
                          
                          <table>
                            <thead></thead>
                            <tbody>

                              <tr>
                                <td>Custno</td>
                                <td>
                                  { addConsignmentPopup.custnoClicked !== null ? (
                                      <React.Fragment>
                                        {addConsignmentPopup.custnoClicked}
                                      </React.Fragment>
                                    )
                                    :
                                    <input type="text" id="iAddCustno" name="nAddCustno" size="15" readOnly onInput={ e => setInsertItemState({...insertItemState, CUSTNO: e.target.value.toUpperCase()}) }/>
                                  }
                                </td>
                              </tr>
                              <tr>
                                <td>Partno</td>
                                <td>
                                  <input type="text" id="iAddPartno" name="nAddPartno" size="15" onInput={ e => setInsertItemState({...insertItemState, PARTNO: e.target.value.toUpperCase()}) }/>                                   
                                </td>
                              </tr>                              
                              {/* <tr>
                                <td>
                                  Onhand 
                                </td>
                                <td>
                                  <input type="text" id="iAddOnhand" name="nAddOnhand" size="15" onInput={ e => setInsertItemState({...insertItemState, ONHAND: e.target.value.toUpperCase()}) }/>
                                </td>
                              </tr> */}
                              <tr>
                                <td>Consign</td>
                                <td>
                                  <input type="number" id="iAddConsign" name="nAddConsign" size="5" 
                                    style={ {textAlign: 'center', width: '50%' } }
                                    defaultValue={ addConsignmentPopup.consignmentClickedDetails[4] !== null ? ( addConsignmentPopup.consignmentClickedDetails[4] ) : '' } 
                                    onInput={ e => setInsertItemState({...insertItemState, CONSIGN: e.target.value}) } />
                                </td>
                              </tr>
                              <tr><td>Consigned On</td><td>{ addConsignmentPopup.consignmentClickedDetails[5] !== null ? ( addConsignmentPopup.consignmentClickedDetails[5] ) : '' }</td></tr>
                              <tr><td>Last Sale</td><td>{ addConsignmentPopup.consignmentClickedDetails[6] !== null ? ( addConsignmentPopup.consignmentClickedDetails[6] ) : '' }</td></tr>
                              <tr><td>Profile Price</td><td>{ addConsignmentPopup.consignmentClickedDetails[7] !== null ? ( addConsignmentPopup.consignmentClickedDetails[7] ) : '' }</td></tr>
                              <tr><td>Core Price</td><td>{ addConsignmentPopup.consignmentClickedDetails[8] !== null ? ( addConsignmentPopup.consignmentClickedDetails[8] ) : '' }</td></tr>
                              <tr><td>Last Sale Price</td><td>{ addConsignmentPopup.consignmentClickedDetails[9] !== null ? ( addConsignmentPopup.consignmentClickedDetails[9] ) : '' }</td></tr>  
                              <tr>
                                <td></td>
                                <td>
                                  <button className="manageConfirmBtnClass" onClick={ (e) => { addConsignmentItemBtnConfirmOnClick(); } }>Add Consignment Item</button>
                                </td>
                              </tr>                            
                            </tbody>

                          </table>                        
                        </div>
                    </div>
                </div>
              </React.Fragment>

              
              )            
            }

          </div>
        </div>

      </main>


    </div>

  );
}


const mapStateToProps = (state) => {
 return {
    authreducerState: state.authreducer,
    addConsignmentPopup: state.consignmentsPostReducer['items_addConsignmentPopup'],  
    noticeMessage: state.consignmentsPostReducer['items_noticeMessage'],    

    
 }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_insertItemsRow: (rowState, addConsignmentPopup) => {
      dispatch(fetchInsertItemsRow(rowState, addConsignmentPopup));
    },
    set_AddConsignmentPopup: (rowState) => {
      dispatch(setAddConsignmentPopup(rowState));
    },
    reset_NoticeMessage: (rowState, addConsignmentPopup) => {
      dispatch(resetNoticeMessage(rowState, addConsignmentPopup));
    }       
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InsertItemModel);